const requireModule = require.context('.', false, /\.store\.js$/)
const modules = {}

requireModule.keys().forEach(filename => {
  const moduleName = filename
    .replace(/(\.\/|\.store\.js)/g, '')
    .replace(/([-_][a-z])/g, group => group.toUpperCase().replace('-', '').replace('_', ''))

  if (moduleName === 'template') return
  modules[moduleName] = requireModule(filename).default || requireModule(filename)
})
export default modules
